<template>
  <div class="form-column">
    <div class="label text-smaller text-bold">
      Line {{ index + 1 }}
    </div>
    <div style="position: relative;">
      <label class="file-wrap" style="margin-top: .25em;">
        <input
          type="file"
          ref="fileInput"
          :disabled="loading || disabled"
          @change="updateFileName"
        >
        <div class="fake">
          <div class="fake-top">
            <span>Select a file</span>
          </div>
          <div class="fake-bottom">
            <span class="truncate">{{ fileName }}</span>
          </div>
        </div>
      </label>
      <div
        v-if="loading"
        class="loading-overlay flex flex-align-center flex-justify-center"
      >
        <SvgSpinner size="4em" />
      </div>
    </div>
    <div v-if="fileSelected && !loading">
      <button
        class="button button-link button-thin button-smaller button-clean text-normal"
        style="padding-left: 0; padding-right: 0;"
        type="button"
        @click="resetFile()">
        Remove File
      </button>
    </div>
    <p class="text-tiny no-margin-bottom" style="margin-top: .25em;">
      <em>*Custom logos may result in a $25 set up charge. This fee will be waived if your logo is already on&nbsp;file.</em>
    </p>
  </div>
</template>

<script>
import SvgSpinner from './SvgSpinner';
import { getNestedProperty } from '../helpers.js';

export default {
  components: {
    SvgSpinner,
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: 0,
    },
    line: {
      required: true,
      type: Object,
    },
    logo: {
      default: () => {},
      type: Object,
    },
  },

  data() {
    return {
      loading: false,
    };
  },

  methods: {
    getNestedProperty,

    async resetFile() {
      this.$refs.fileInput.value = '';

      await this.$http.delete('/eartag/logo', {
        data: {
          filename: this.logo.path,
        }
      }).catch(error => {
        window.console.log(error);
      });

      this.$emit('update:line', Object.assign(
        {},
        this.line,
        {value: null}
      ));

      this.$emit('uploaded-logo');
    },

    async updateFileName(e) {
      if(e.target.files.length > 0) {
        this.$emit('update:line', Object.assign(
          {},
          this.line,
          {value: 'logo'}
        ));

        this.loading = true;

        await this.uploadFile(e.target.files[0]);

        this.loading = false;

        return;
      }

      await this.resetFile();
    },

    async uploadFile(file) {
      let formData = new FormData();
          formData.append('logo', file);

      const { data: response } = await this.$http.post('/eartag/logo', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).catch(error => {
        window.console.log(error);
      });

      // handle error

      this.$emit('uploaded-logo', response);
    },
  },

  computed: {
    fileName() {
      return this.getNestedProperty(this.logo, ['origname']) || 'No file selected';
    },

    fileSelected() {
      return (this.logo || {}).origname !== '';
    },
  },
}
</script>

<style scoped>
.file-wrap {
  cursor: pointer;
  display: block;
  position: relative;
  width: 100%;
}
.file-wrap > input {
  cursor: pointer;
  height: 100%;
  left: 0;
  opacity: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.fake {
  background-color: #FFF;
  border: 1px solid #979797;
  border-radius: .25em;
}

.fake-top {
  align-items: center;
  background-color: #979797;
  color: #FFF;
  display: flex;
  height: 3em;
  letter-spacing: .075em;
  justify-content: center;
  padding: 0 .75em;
  text-transform: uppercase;
}
.file-wrap > input:hover + .fake {
  border-color: #a4a4a4;
  box-shadow: 0 0 0.5em 0.2em rgba(122,122,122,.2);
}
.file-wrap > input:hover + .fake > .fake-top {
  background-color: #a4a4a4;
}
.file-wrap > input:focus + .fake {
  border-color: #006fd0;
  box-shadow: inset 0 0.2em 0.5em rgba(0,0,0,.09),
              0 0 0.5em 0.1em rgba(0,84,157,.75);
}
.file-wrap > input:focus + .fake > .fake-top {
  background-color: #006fd0;
}

.fake-bottom {
  align-items: center;
  display: flex;
  font-size: 0.875em;
  font-weight: normal;
  height: 3em;
  padding: 0 .5em;
}
.fake-bottom > span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.loading-overlay {
  background-color: rgba(0, 0, 0, 0.35);
  border-radius: .25em;
  color: #00549d;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
</style>
